import styled from "@emotion/styled";
import { PRIMARY_BLACK, SECONDARY_GREY } from "src/constants/colors";
import { HEADER_HEIGHT } from "src/constants";
import { Link } from "react-router-dom";

export const Container = styled.div<{ showHeader?: boolean }>`
  display: flex;
  flex-direction: row;
  overflow: hidden;
  margin-top: ${({ showHeader }) => (showHeader ? HEADER_HEIGHT : "0px")};
`;

export const Header = styled.div<{ headerHeightValue: number }>`
  box-sizing: border-box;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 1000;
  display: flex;
  flex-direction: ${({ headerHeightValue }) =>
    headerHeightValue > HEADER_HEIGHT ? "column" : "row"};
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${SECONDARY_GREY};
`;

export const LeftPane = styled.div<{
  hasBorder?: boolean;
  showHeader: boolean;
  headerHeight?: number;
  isCollapsed?: boolean;
}>`
  position: fixed;
  top: ${({ showHeader, headerHeight = HEADER_HEIGHT }) =>
    showHeader ? headerHeight : 0}px;
  width: ${({ isCollapsed }) => (isCollapsed ? "64px" : "272px")};
  height: calc(
    100vh -
      ${({ showHeader, headerHeight = HEADER_HEIGHT }) =>
        showHeader ? headerHeight : 0}px
  );
  display: flex;
  flex-direction: column;
  transition: width 0.3s ease-in-out;
  ${({ hasBorder }) =>
    hasBorder && "border-right: 1px solid rgba(228, 231, 236, 1)"};
  z-index: 49;
`;

export const RightPane = styled.div<{
  showHeader: boolean;
  headerHeight?: number;
  overflowX?: string;
  isCollapsed?: boolean;
}>`
  margin-left: ${({ isCollapsed }) => (isCollapsed ? "64px" : "272px")};
  margin-top: ${({ showHeader, headerHeight = HEADER_HEIGHT }) =>
    showHeader ? `${headerHeight}px` : "0"};
  min-height: calc(100vh - 67px);
  flex: 1;
  min-width: 0;
  box-sizing: border-box;
  overflow-x: ${({ overflowX }) => overflowX || "hidden"};
  overflow-y: auto;
  transition: all 0.3s ease-in-out;
`;
